import React from 'react';

interface CooldownButtonProps {
  onClick: () => void;
  label: string;
  cooldownSeconds: number;
  disabled?: boolean;
}

const CooldownButton: React.FC<CooldownButtonProps> = ({
  onClick,
  label,
  cooldownSeconds,
  disabled = false,
}) => {
  const isCooling = cooldownSeconds > 0;
  const isDisabled = disabled || isCooling;

  return (
    <button type="button" onClick={onClick} disabled={isDisabled} className="btn-primary">
      {isCooling ? (
        <>
          <span className="opacity-80">Wait</span>
          <span className="kbd bg-white/20 text-white border-white/30">{cooldownSeconds}s</span>
        </>
      ) : (
        label
      )}
    </button>
  );
};

export default CooldownButton;
